import { render, staticRenderFns } from "./event.layout.vue?vue&type=template&id=b6ccca12&scoped=true"
import script from "./event.layout.ts?vue&type=script&lang=ts&external"
export * from "./event.layout.ts?vue&type=script&lang=ts&external"
import style0 from "./event.layout.vue?vue&type=style&index=0&id=b6ccca12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ccca12",
  null
  
)

export default component.exports